import React from "react";

const ConfirmationModalv2 = ({
  isOpen,
  heading,
  message,
  onClose,
  onConfirm,
  confirmText = "OK",   // default text for confirm button
  cancelText = "Cancel" // default text for cancel button
}) => {

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 10,
      }}
    >
      <div
        style={{
          background: "white",
          padding: "20px",
          borderRadius: "8px",
          textAlign: "center",
          maxWidth: "500px",
          minWidth: "320px"
        }}
      >
        <h2 style={{ margin: "10px 0" }}>{heading}</h2>
        <p style={{ textAlign: "left", fontWeight: "bold", marginBottom: "20px" }}>
          {message}
        </p>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
          <button
            onClick={onClose}
            style={{
              padding: "8px 16px",
              border: "1px solid #ccc",
              background: "white",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            {cancelText}
          </button>

          <button
            onClick={onConfirm}
            style={{
              padding: "8px 16px",
              border: "none",
              background: "#d9534f", // red for delete-type
              color: "white",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModalv2;
